import * as Yup from "yup";
import { tr } from "yup-locales";
import { language } from "../languages/tr";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const PaymentShema = Yup.object().shape({
  PaymentName: Yup.string().required(),
  cardNumber: Yup.string()
    .length(19, language.cardNumberLength)
    .required(),
  month: Yup.string()
    .matches(/0[1-9]|1[0-2]/)
    .required(),
  year: Yup.string()
    .matches(/^\d{2}$/)
    .required(),
  cvv: Yup.string()
    .matches(/^\d{3}$/)
    .required(),
  sozlesme: Yup.boolean().isTrue(),
  kvkk: Yup.boolean().isTrue(),
});
